import { gql } from '@apollo/client';

export const USE_ALL_CREDITS = gql`
  query credits($state: [Int], $order: [[String]], $limit: [Int]) {
    credits(state: $state, order: $order, limit: $limit) {
      cConsecutive
      cId
      creditPayrollCompany {
        cpcIdeNum
        creditPayrollStaff {
          cpsFirNam
          cpsSecNam
          cpsFirLas
          cpsSecLas
        }
        company {
          cBusNam
          sellerCompany {
            seller {
              sBusiness
              sFirNam
              sSecNam
              sFirLas
              sSecLas
            }
          }
        }
      }
      cName
      cReqVal
      cDatCre
      cState
      payrollCompany {
        pcId
        pcState
        payrollStaff {
          clcId
          clientCategory {
            clcColor
            clcName
          }
        }
      }
    }
  }
`;

export const CREDITS_LIST_EXCEL = gql`
  query CreditListExcel(
    $page: Int
    $pageSize: Int
    $queryValue: String
    $finalDate: String
    $order: [[String]]
    $initialDate: String
    $includeBrokerageCommission: Boolean! = false
  ) {
    creditListExcel(
      page: $page
      pageSize: $pageSize
      queryValue: $queryValue
      finalDate: $finalDate
      order: $order
      initialDate: $initialDate
    ) {
      creditList {
        cId
        cName
        cConsecutive
        cPreviousConsecutive
        cMigratedCredit
        pcIdeNum
        payrollName
        company
        affiliationNumber
        dateBirtDay
        dateExpedition
        cityExpedition
        address
        cityHome
        phone
        email
        creditLine
        creditCards {
          cId
          ccBalance
          ccName
        }
        sellerCode
        seller
        sellerIdeNum
        sellerTypeIdentity
        cReqVal
        cDate
        activePhaseName
        state
        rejectionComment
        cell
        cBalance
        fee
        term
        total
        totalNeto
        applicationDate
        cFirFee
        ecDatCon
        ecDatInc
        cMigratedCredit
        cPreviousConsecutive
        brokerageCommission @include(if: $includeBrokerageCommission) {
          percentage
          value
        }
      }
      totalCount
      totalDocs
      hasNextPage
      hasPreviousPage
      totalPages
      currentPage
    }
  }
`;

export const CREDITS_LIST = gql`
  query CreditList(
    $finalDate: String
    $initialDate: String
    $pageSize: Int
    $page: Int
    $queryValue: String
    $order: [[String]]
  ) {
    creditList(
      finalDate: $finalDate
      initialDate: $initialDate
      pageSize: $pageSize
      page: $page
      queryValue: $queryValue
      order: $order
    ) {
      creditList {
        cId
        cName
        cConsecutive
        cPreviousConsecutive
        cMigratedCredit
        pcIdeNum
        payrollName
        company
        seller
        cReqVal
        cDate
        cFirFee
        state
        clcColor
        creditPhases {
          cpName
          cpActivePhase
        }
      }
      totalCount
      totalDocs
      hasNextPage
      hasPreviousPage
      currentPage
      totalPages
    }
  }
`;

export const REPORT_CREDITS_INFORMATION = gql`
  query Query {
    getReportInformationCreditPayrollCompanies
  }
`;

export const REPORT_CENTRAL_RISK = gql`
  query Query {
    getReportCentralRisk
  }
`;

export const CREDIT_DOCUMENTS = gql`
  query CreditDocuments($cId: ID) {
    creditDocuments(cId: $cId) {
      cdId
      cdGroup
      cdCategory
      cdName
      cdRoute
    }
    creditReports(cId: $cId, state: [1], order: [["crId", "ASC"]]) {
      crId
      notification {
        nName
      }
      creditReportDocuments {
        crdId
        crdFileName
        crdState
      }
    }
    getCreditDiscountCapacityInformationByCreditId(cId: $cId) {
      cdciId
      cdciPdfRoute
    }
  }
`;

export const DOWNLOAD_DOCUMENT = gql`
  mutation DownloadDocuments($input: DownloadDocuments!) {
    downloadDocuments(input: $input) {
      base64
    }
  }
`;

export const CREDITS_DISBURSED_IDS = gql`
  query CreditsDisbursedIds($order: [[String]]) {
    creditsDisbursedIds(order: $order) {
      cId
      cConsecutive
    }
  }
`;

export const PAYROLL_DOCS_FOR_DOWNLOAD = gql`
  query GetPayrollDocsForDownload($cId: ID) {
    getCreditPayrollCompanyById(cId: $cId) {
      cpcId
      pcId
      creditPayrollDocument {
        cpdPerDoc
        cpdFroDoc
        cpdReaDoc
        cpdSerDoc
        cpdPayRemDoc
        cpdBanDoc
        cpdConDoc
        cpdComActDoc
        cpdBudRecDoc
        cpdBudCerDoc
        cpdRut
        cpdComChamber
        cpdInstitutionPic
        cpdWorkCertificate
        cpdVoucher
        cpdBankStatement
        cpdFinancialStatements
        cpdIncomeTaxReturn
        cpdBoardDirectors
        cpdTradeBalance
        cpdRealEstateRegistration
        cpdVehicleOwnershipCard
        cpdCommercialReference
        cpdBankReference
        cpdIncomeWithholdings
        cpdCadastreAndValuation
        cpdCommercialAppraisal
        cpdLeaseCertificate
        cpdLibertyAndTraditionCertificate
      }
      creditPayrollCompanyOtherDocuments {
        cpcodFileName
        cpcodState
      }
    }
    getCreditPayrollDocumentToRequest(cId: $cId) {
      dtrId
      dtrName
      fileName
    }
  }
`;
